import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import { getPathWithoutLang } from 'shared/lib/converter';
import { SEO_LANGS, isIndexablePath, langHref, normalizeBasePath } from 'shared/lib/seo';

/**
 * @description
 * 현재 페이지의 언어별 대체 URL(hreflang)을 <head>에 주입합니다.
 * 같은 콘텐츠의 각 언어판을 검색엔진에 알려, 국가/언어에 맞는 버전이 노출되게 합니다.
 * 모든 언어판에 동일한 전체 집합을 넣어 상호 참조(reciprocal) + 자기 참조를 만족시킵니다.
 *
 * react-helmet 은 React 18 동시성 렌더링 레이스로 태그가 유실될 수 있어(SeoMetaTags.tsx 참고)
 * useEffect 로 <link> 를 직접 관리합니다. 색인 대상 공개 페이지에만 주입 —
 * noindex 대상(마이페이지·카트·결제 등)에 hreflang 이 남으면 서치콘솔에
 * "대체 페이지에 noindex 태그 있음" 경고가 쌓입니다.
 */
function Hreflang() {
  const { pathname } = useLocation();

  useEffect(() => {
    const removeAll = () => {
      document.head.querySelectorAll('link[data-seo-hreflang]').forEach((el) => el.remove());
    };
    removeAll();

    const basePath = normalizeBasePath(getPathWithoutLang(pathname));
    if (!isIndexablePath(basePath)) return undefined;

    const alternates = [
      ...SEO_LANGS.map((lang) => ({ lang, href: langHref(lang, basePath) })),
      { lang: 'x-default', href: langHref('en', basePath) },
    ];

    alternates.forEach(({ lang, href }) => {
      const el = document.createElement('link');
      el.setAttribute('rel', 'alternate');
      el.setAttribute('hreflang', lang);
      el.setAttribute('href', href);
      el.dataset.seoHreflang = 'true';
      document.head.appendChild(el);
    });

    return removeAll;
  }, [pathname]);

  return null;
}

export default Hreflang;
